<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Familiares' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <ion-card>
    <ion-card-header>
      <i class="fa-solid fa-user-group">
        <ion-label class="title">{{'Meus Familiares' | translate}}</ion-label>
      </i>
    </ion-card-header>

    <ion-list *ngFor="let a of familiares;">
      <ion-item (click)="selecionar(a);">
        <ion-avatar slot="start">
          <img [src]="a.foto | image:' '" />
        </ion-avatar>

        <ion-label>
          <h3 class="">{{a.nome}}</h3>
          <p class="">{{a.parentesco | translate}}</p>
        </ion-label>

        <ion-icon class="icon-list" slot="end" name="arrow-forward-sharp"></ion-icon>
      </ion-item>
    </ion-list>

    <sem-registro *ngIf="!familiares.length"> </sem-registro>
  </ion-card>
</ion-content>
